/**
 * Note unique du site. Toute page qui émet `aggregateRating` doit aussi afficher
 * le bloc `<AggregateRating />`: Google exige que le rendu et le schéma concordent.
 * Module séparé parce que `technical-seo.ts` en a besoin et qu'il est importé par
 * des composants clients, qui ne doivent pas tirer `seo.ts`.
 */
export const SUM_AGGREGATE_RATING = {
  ratingValue: 4.8,
  reviewCount: 126,
  bestRating: 5,
  worstRating: 1,
} as const;
